import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { requestDepartmentLaboratoryService } from 'shared/services';
import toast from 'shared/utils/toast';
import RequestDepartmentTranscodeForm from '../components/RequestDepartmentTranscodeForm';

const initTranscode = {
  id: null,
  laboratory: null,
  department: null
};

export const CreateRequestDepartmentTranscode = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.request-dep-lab.new';

  const createTranscode = async (values) => {
    requestDepartmentLaboratoryService.add(values).then((res) => {
      if (res) toast.success('Transcodifica aggiunta con successo.');
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <RequestDepartmentTranscodeForm transcode={initTranscode} onSubmit={createTranscode} />
    </TenantPage>
  );
};

export default CreateRequestDepartmentTranscode;
